<template>
    <div class="overflow-hidden border border-gray-300 rounded-md">
        <div class="flex items-center bg-gray-100">
            <div class="w-16"></div>
            <div class="w-2/12 py-2 px-2 font-bold">Место показа</div>
            <div class="w-2/12 py-2 px-2 font-bold">Позиция на странице</div>
            <div class="w-2/12 py-2 px-2 font-bold">Код AppsFlyer</div>
            <div class="w-2/12 py-2 px-2 font-bold">Название</div>
            <div class="w-1/12 py-2 font-bold">Активен</div>
        </div>

        <Draggable v-model="list" tag="div">
            <div
                v-for="item in list"
                :key="item.id"
                class="flex items-center h-10 py-4 border-t border-gray-300"
            >
                <div class="w-16 flex items-center justify-content-center">
                    <CIcon
                        :height="16"
                        :content="cilCursorMove"
                        class="handle" />
                </div>
                <div class="w-2/12 truncate px-2">
                    {{ routeNamesMap[item.route_name] }}
                </div>
                <div class="w-2/12 truncate px-2">
                    {{ item.place }}
                </div>
                <div class="w-2/12 truncate px-2">
                    {{ item.code }}
                </div>
                <div class="w-2/12 py-2">
                    <span
                        class="text-purple-700 cursor-pointer hover:underline"
                        :title="item.route_name"
                        @click="$emit('select', item.id)"
                    >{{ formatTitle(item.title) }}
                    </span>
                </div>
                <div class="w-1/12">
                    <CBadge :color="item.enabled ? 'success' : 'secondary'">
                        {{ item.enabled ? "Да" : "Нет" }}
                    </CBadge>
                </div>
            </div>
        </Draggable>
    </div>
</template>

<script>
    import Draggable from 'vuedraggable';
    import { cilCursorMove } from '@coreui/icons';
    const { formatDate } = require('../../utils/views');

    export default {
        components: {
            Draggable,
        },

        props: {
            data: {
                type: Array,
                default: () => [],
            },
        },

        data: () => ({
            cilCursorMove,
            routeNamesMap: {
                'restaurant-list': 'Список ресторанов',
                'grocery-list': 'Список продуктовых магазинов',
                'pharmacy-list': 'Список аптек',
                'assistant-list': 'Список помощников',
            }
        }),

        computed: {
            list: {
                get() {
                    return this.data;
                },

                set(v) {
                    const updated = v.map((item, idx) => {
                        item.position = idx + 1
                        return item;
                    });

                    this.$emit('update:data', updated);
                }
            },
        },

        async mounted() {
            try {
                (await this.axios.get('/entities-type')).data.map(type => {
                    this.$set(this.routeNamesMap, `entity-list-${type.code}`, type.title);
                });
            } catch (err) {
                this.$root.$emit('showError', 'Ошибка загрузки данных. ' + err);
            }
        },

        methods: {
            formatDate(date) {
                return formatDate(date);
            },
            formatTitle(title) {
                return (title && title.trim()) ? title.trim() : 'Без названия';
            }
        },
    };
</script>
